import { render } from "./BloquesGuardados.vue?vue&type=template&id=0ad2991c&scoped=true"
import script from "./BloquesGuardados.vue?vue&type=script&lang=js"
export * from "./BloquesGuardados.vue?vue&type=script&lang=js"

import "./BloquesGuardados.vue?vue&type=style&index=0&id=0ad2991c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ad2991c"

export default script